module.exports = __webpack_public_path__ + "media/public/img/product-information-preview-5cd5d0acc56d0f63c99a9b080a5e7d78.png";